import React from "react";
import { Control } from "react-redux-form";
import DatePicker from "react-datepicker";
import moment from "moment";

export default ({
  viewDateFormat = "YYYY-MM-DD",
  modelDateFormat = "YYYY-MM-DD",
  ...props
}) => (
  <Control.custom
    component={DatePicker}
    mapProps={{
      selected: (ownProps) =>
        ownProps.modelValue ? moment(ownProps.modelValue) : null,
      onChange: (ownProps) => (value) => {
        const m = moment(value);
        return ownProps.onChange(
          m.isValid() ? m.format(modelDateFormat) : null
        );
      },
      onBlur: (ownProps) => ownProps.onBlur,
      onFocus: (ownProps) => ownProps.onFocus,
    }}
    dateFormat={viewDateFormat}
    autoComplete="off"
    // yearDropdownItemNumber={20}
    // scrollableYearDropdown
    // showYearDropdown="true"
    // showYearPicker
    peekNextMonth
    showMonthDropdown
    showYearDropdown
    dropdownMode="select"

    {...props}
  />
);
